import { render, staticRenderFns } from "./redelivery.vue?vue&type=template&id=febf23ba&scoped=true"
import script from "./redelivery.vue?vue&type=script&lang=js"
export * from "./redelivery.vue?vue&type=script&lang=js"
import style0 from "./redelivery.vue?vue&type=style&index=0&id=febf23ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febf23ba",
  null
  
)

export default component.exports